var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { resolveConfig } from '@office-start/config-resolver-service';
import { useFeatureGates } from '@office-start/feature-gates-service';
import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { OfficeHomeApp } from '@office-start/office-home-app';
import { OfficeWorkload } from '@office-start/officehome-types';
import { logFeature } from '@office-start/telemetry-service';
import { KnownFeatureNames, } from '@office-start/telemetry-types';
import { StrictMode, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { ReactQueryDevtools } from 'react-query-devtools';
import { unregister } from './serviceWorker';
var ServiceWorkerSetup = function () {
    var _a, _b;
    var featureGates = useFeatureGates().data;
    var isServiceWorkerEnabled = (_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _a === void 0 ? void 0 : _a.serviceWorkerGates) === null || _b === void 0 ? void 0 : _b.serviceWorkerEnabled;
    useEffect(function () {
        if (isServiceWorkerEnabled === false) {
            unregister();
        }
    }, [isServiceWorkerEnabled]);
    return null;
};
export var renderPwaOhome = function () { return __awaiter(void 0, void 0, void 0, function () {
    var startupConfig, sharedContext, reactShellConfig, officeHomeApiConfig, officeExperienceContext, desktopContext, e_1;
    var _a, _b, _c, _d, _e, _f;
    return __generator(this, function (_g) {
        switch (_g.label) {
            case 0:
                window.wamAccessTokenRequests = new Map();
                window.shellTokenRequestDictionary = {};
                _g.label = 1;
            case 1:
                _g.trys.push([1, 6, , 7]);
                return [4 /*yield*/, resolveConfig('clientStartupConfiguration')];
            case 2:
                startupConfig = _g.sent();
                return [4 /*yield*/, resolveConfig('sharedContext')];
            case 3:
                sharedContext = _g.sent();
                return [4 /*yield*/, resolveConfig('reactShellConfiguration')];
            case 4:
                reactShellConfig = _g.sent();
                return [4 /*yield*/, resolveConfig('officeHomeApiConfig')];
            case 5:
                officeHomeApiConfig = _g.sent();
                if (!startupConfig ||
                    !sharedContext ||
                    !reactShellConfig ||
                    !officeHomeApiConfig) {
                    throw new Error('Failed to resolve desktop configs');
                }
                officeExperienceContext = {
                    cdnDomain: startupConfig.officeStartCdnDomain,
                    correlationId: startupConfig.sharedClientStartupContext.correlationId,
                    sessionId: startupConfig.sharedClientStartupContext.sessionId,
                    deploymentEnvironment: startupConfig === null || startupConfig === void 0 ? void 0 : startupConfig.sharedClientStartupContext.deploymentEnvironment,
                    geoName: startupConfig.sharedClientStartupContext.geoName,
                    requestOrigin: startupConfig.sharedClientStartupContext
                        .requestOrigin,
                    preferredCulture: sharedContext.officeMarket,
                    inMockMode: sharedContext.inMockMode,
                    officeHomeApiRoot: sharedContext.officeHomeApiRoot,
                    officeMarketLcid: sharedContext.officeMarketLcid,
                    isCorpNet: startupConfig.sharedClientStartupContext.corpNet,
                    officeStartManifestVersion: sharedContext.officeStartManifestVersion,
                    stringsContainerName: 'officestartstrings',
                    buildDateUtc: startupConfig.sharedClientStartupContext.buildDateUtc,
                    buildVersion: process.env.BUILD_ID || '',
                    domainOrigin: startupConfig.sharedClientStartupContext
                        .domainOrigin,
                    wrapperVersion: typeof Windows !== 'undefined'
                        ? (_d = (_c = (_b = (_a = Windows === null || Windows === void 0 ? void 0 : Windows.ApplicationModel) === null || _a === void 0 ? void 0 : _a.Package) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.id) === null || _d === void 0 ? void 0 : _d.version
                        : undefined,
                    dataBoundary: (startupConfig.dataBoundary == 'EU'
                        ? 'EU'
                        : undefined),
                    flights: startupConfig.sharedClientStartupContext.flights,
                    ecsRing: startupConfig.sharedClientStartupContext
                        .ecsRing,
                    loginHint: startupConfig.loginHint,
                    thirdPartyNoticeUrl: window.thirdPartyNoticeUrl
                        ? window.thirdPartyNoticeUrl
                        : reactShellConfig === null || reactShellConfig === void 0 ? void 0 : reactShellConfig.thirdPartyNoticeUrl,
                    testTraffic: reactShellConfig === null || reactShellConfig === void 0 ? void 0 : reactShellConfig.testTraffic,
                    logoutUrl: reactShellConfig === null || reactShellConfig === void 0 ? void 0 : reactShellConfig.logoutUrl,
                    appSwitchUrl: (_e = reactShellConfig === null || reactShellConfig === void 0 ? void 0 : reactShellConfig.acctSwitchingConfig) === null || _e === void 0 ? void 0 : _e.appSwitchUrl,
                    appSwitchToUrl: (_f = reactShellConfig === null || reactShellConfig === void 0 ? void 0 : reactShellConfig.acctSwitchingConfig) === null || _f === void 0 ? void 0 : _f.appSwitchToUrl,
                };
                desktopContext = {
                    aadAppId: '0ec893e0-5785-4de6-99da-4ed124e5296c',
                    workload: OfficeWorkload.Hwa,
                    defaultLinkTarget: sharedContext.defaultLinkTarget,
                    jwtAuthEnabled: officeHomeApiConfig.jwtAuthEnabled,
                };
                ReactDOM.render(_jsxs(_Fragment, { children: [_jsxs(StrictMode, { children: [_jsx(OfficeHomeApp, { props: officeExperienceContext, commonContext: desktopContext }), _jsx(ServiceWorkerSetup, {})] }), _jsx(ReactQueryDevtools, { initialIsOpen: false })] }), document.getElementById('root'));
                logFeature({
                    featureName: KnownFeatureNames.Hwa,
                    eventName: KnownInstrumentationEvents.PwaBootstrapEnd,
                });
                return [3 /*break*/, 7];
            case 6:
                e_1 = _g.sent();
                console.error('Error parsing config for Windows App', e_1);
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}); };
